<template>
<el-dialog class="virtualmap-fullscreen" :visible.sync="visible" :append-to-body="true" :show-close="false" fullscreen :modal="false" center @open="opened" @close="closed">
  <el-row slot="title" type="flex" justify="space-between" align="middle" class="virtualmap-fullscreen__header">
    <span class="virtualmap-fullscreen__title">{{ title }}</span>
  </el-row>
<div class="virtual-map-frame page-container-content tabgroup">
  <div class="full-wrapper">
    <div class="left-area">
      <w-virtual-map-tree ref="virtualMapTree" @select-target="selectTarget" :fullscreen-flag="true"/>
    </div>
    <div class="right-area">
      <w-virtual-map-timeline v-if="showTimelineFlag" :active="active && showTimelineFlag" @select-target-map="selectTargetMap"/>
      <w-virtual-map-info v-else :selected-params = "selectedParams" @change-show-timeline-flag="changeShowTimelineFlag"/>
    </div>
    <div class="bottom-area full-f-chart">
      <w-virtual-map-event-info class="no-spacing-bottom" :selected-node="selectedNode" :active="active"></w-virtual-map-event-info>
    </div>
  </div>
</div>
</el-dialog>
</template>

<script>
import API from '@/api/virtual/performance/virtualmap';
import WVirtualMapEventInfo from '@/views/performance/components/virtual/VirtualMapEventInfo';
import WVirtualMapTree from '@/views/performance/components/virtual/VirtualMapTree';
import WVirtualMapTimeline from '@/views/performance/components/virtual/VirtualMapTimeline';
import WVirtualMapInfo from '@/views/performance/components/virtual/VirtualMapInfo';
import { mapGetters } from 'vuex';
import { isEmpty } from '@/utils/basic';

export default {
  name: 'WVirtualMapFrameFullscreenPopup',
  components: {
    WVirtualMapEventInfo,
    WVirtualMapTree,
    WVirtualMapTimeline,
    WVirtualMapInfo,
  },
  data() {
    return {
      showTimelineFlag: true,
      selectedParams: {},
      configActive: false,
      visible: false,
      conforming: false,
      active: false,
    };
  },
  computed: {
    title() {
      return this.selectedNode ? this.selectedNode.label : '';
    },
    ...mapGetters(['selectedNode', 'selectedObjDefineIds']),
  },
  watch: {
    active: {
      handler(newValue) {
        if (newValue) {
          this.loadStore();
        }
      },
    },
  },
  methods: {
    loadStore() {
      const { selectedNode } = this;
      let id = selectedNode.obj && selectedNode.obj.objId;
      let idType = 'objId';
      const hypervisorType = selectedNode.hypervisorType;
      if (isEmpty(id)) {
        id = selectedNode.virtualcenterGroupId;
        idType = 'virtualcenterGroupId';
      }
      if (id) {
        API.vmsTreeLayout(id, idType, hypervisorType).then((response) => {
          if (response.data.success) {
            const responseData = response.data.data;
            if (this.$refs.virtualMapTree) {
              this.$refs.virtualMapTree.drawVirtualMapTree(responseData);
            }
          }
        });
      }
    },
    /**
     * Map 에서 대상이 선택됐을 경우 선택된 대상 설정
     * @author kimjy
     * @param  {Object} obj {objId, objName, objtypeId}
     */
    selectTarget(obj) {
      this.showTimelineFlag = false;
      this.selectedParams = obj;
    },
    /**
     * 타임라인에서 대상이 선택됐을 경우 선택된 대상을 Map에 설정
     * @author kimjy
     * @param  {Integer} objId
     */
    selectTargetMap(objId) {
      this.$refs.virtualMapTree.clickedNodeFromTimeLine(objId);
    },
    changeShowTimelineFlag(flag) {
      this.$nextTick(() => {
        this.$refs.virtualMapTree.changeShowTime(flag);
        this.showTimelineFlag = flag;
      });
    },
    open() {
      this.visible = true;
      this.$store.dispatch('openFullScreenLayer');
    },
    close() {
      this.visible = false;
      this.$store.dispatch('closeFullScreenLayer');
    },
    opened() {
      window.addEventListener('resize', this.loadData);
      window.addEventListener('keyup', this.onConfirmClose);
      setTimeout(() => {
        this.$message('전체화면을 종료하려면 ESC를 누르십시오.');
        this.loadStore();
        this.active = true;
      }, 100);
    },
    closed() {
      window.removeEventListener('resize', this.loadData);
      window.removeEventListener('keyup', this.onConfirmClose);
    },
    onConfirmClose(evt) {
      if (this.visible && evt.keyCode === 27 && !this.conforming) {
        this.conforming = true;
        this.$confirm('전체화면을 종료하시겠습니까?', '확인', {
          confirmButtonText: '예',
          cancelButtonText: '아니오',
          confirmButtonClass: 'el-button--solid',
          closeOnPressEscape: false,
        })
          .then(() => {
            this.initDatas();
            this.close();
          })
          .catch(() => {})
          .finally(() => {
            this.conforming = false;
          });
      }
    },
    initDatas() {
      this.showTimelineFlag = true;
      this.selectedParams = {};
      this.configActive = false;
      this.visible = false;
      this.conforming = false;
      this.active = false;
    },
  },
};
</script>
<style lang="scss">
.virtualmap-fullscreen {
  .virtual-map-frame {
    height: 100%;
  }
  &__header {
    height: 73px;
    background-color: #717785;
    padding: 25px 35px;
    padding-top: 32px;
  }
  &__title {
    color: #fff;
    font-size: 1.5rem;
    font-weight: 500;
    letter-spacing: -0.01em;
  }
  &__theme-btn {
    /* font-size: 15px; */
    color: #ddd; //$selectedgray
  }
  &__theme-btn > span {
    vertical-align: middle;
    transition: color .5s ease;
    -webkit-transition: color .3s ease;
  }
  &__theme-btn > span.selected {
    color: #ffffff;
  }
  &__switch {
    margin: 0px 5px;
  }
  &__footer {
    padding-top: 4px;
  }
  &__indicator {
    width: 12px;
    display: inline-block;
    height: 12px;
    border-radius: 12px;
    background: #d3d3d3;
    padding: 3px;
    margin: 0 3px;
  }
  &__indicator.active {
    background: #7c7f8e;
  }

  .el-dialog{
    background-color: #eee; //$palegray
    overflow: hidden;    
  }

  .el-dialog__header {
    padding: 0;
  }
  .el-dialog__body {
    box-sizing: border-box;

    *,
    *:before,
    *:after {
        box-sizing: inherit;
    }
    .container {
      width: 100%;
    }
    .carousel-item > div {
      height: 100%;
    }

    .carousel {
        position: relative;
        overflow: hidden;
        width: 100%;
    }

    .carousel-container {
        list-style: none;
        overflow: hidden;
        padding: 0;
        margin: 0;
        width: 500%;
        transition: transform 0.3s cubic-bezier(.694, .0482, .335, 1);
    }

    .carousel-item {
        position: relative;
        float: left;
        width: 20%;
    }

    .carousel-pagination {
        list-style: none;
        position: absolute;
        bottom: 3%;
        left: 0;
        right: 0;
        width: 50%;
        padding: 0;
        margin: 0 auto;
        text-align: center;
        z-index: 10;
    }

    .carousel-bullet {
        display: inline-block;
        width: 12px;
        height: 12px;
        background-color: #000;
        cursor: pointer;
        margin: 0 7px;
        border-radius: 50%;
        opacity: 0.5;
        transition-property: transform, opacity, background-color;
        transition-duration: 0.3s;
    }

    .carousel-bullet:hover {
        -webkit-transform: scale(1.3);
        transform: scale(1.3);
    }

    .carousel-bullet.active-bullet,
    .carousel-bullet.active-bullet:hover {
        opacity: 1;
        -webkit-transform: scale(1.3);
        transform: scale(1.3);
        background-color: #fff;
        cursor: default;
    }
    padding: 14px 14px 0px 14px;
    width: 100%;
    height: calc(100% - 73px - 40px);
    overflow-y: hidden;
    .v-carousel {
      height: 100%;
      overflow: hidden;
      position: relative;
    }
    .v-carousel-items {
      height: 100%;
      overflow: hidden;
    }
    .el-carousel {
      width: 100%;
      height: 100%;
      &__indecator {
        .el-carousel__button {
          background: #d3d3d3;
        }
        &.is-active {
          .el-carousel__button {
            background: #7c7f8e;
          }
        }
      }
    }
  }
  .virtual-map-frame.page-container-content.tabgroup .full-wrapper {
    height: calc(100% - 50px);
    .left-area {
      width: calc(100% - 500px);
      margin-left:0px;
      float:left;
      height: 100%;
      .no-spacing-bottom {
        display: inline-block;
      }
      .full-f-chart.virtual-map-tree {
        height: 100%;
        .svg-wrapper-div {
          height: 100%;
        }
      }
    }
    .right-area {
       width: 500px;
       float: left;
       padding-right: 1px;
       height: 100%;
    }
    // 아래쪽 이벤트 영역에서 CSS를 가져온 것 중 적용시키지 말아야 할 것들을 덮어쓴다.
    .bottom-area.full-f-chart {
      min-height: 0px;
      background-color: transparent;
      padding: 0px;
      margin: 0px;
      -webkit-box-shadow: none;
      box-shadow: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/performance/components/virtual/VirtualMapFrameFullscreenPopup.vue